import { getSiteMaterialUrl } from '../utils/getSiteMaterialUrl';

export const openSiteMaterial = (id: number) => {
  window.open(getSiteMaterialUrl(id), '_self');
};
